export default "__VITE_ASSET__ChKBRvJc__"